import React from "react";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Logo from "shared/Logo/Logo";
import { Disclosure } from "@headlessui/react";
import { NavLink } from "react-router-dom";
import { NavItemType } from "./NavigationItem";
import SocialsList from "shared/SocialsList/SocialsList";
import ButtonThird from "shared/Button/ButtonThird";
import { useTranslation } from "react-i18next";
import { useNavMobile } from "hooks/useNavMobile";
import LangDropdown from "components/LangDropdown";

export interface NavMobileProps {
  data?: NavItemType[];
  onClickClose?: () => void;
}

const NavMobile: React.FC<NavMobileProps> = ({ data, onClickClose }) => {
  const { t } = useTranslation();

  const { _onLogout, isLoggedIn } = useNavMobile();

  const _renderMemberItem = () => {
    return (
      <>
        <Disclosure key={"Home"} as="li" className="text-neutral-900 dark:text-white">
          <NavLink
            end
            className={({ isActive }) => `flex w-full px-4 font-medium uppercase tracking-wide text-sm hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg ${isActive ? "text-secondary" : ""}`}
            to={{
              pathname: "/",
            }}>
            <span className={`py-2.5 pr-3  "block w-full"`}>{t("home")}</span>
          </NavLink>
        </Disclosure>
        <Disclosure key={"Bookings & points"} as="li" className="text-neutral-900 dark:text-white">
          <NavLink
            end
            className={({ isActive }) => `flex w-full px-4 font-medium uppercase tracking-wide text-sm hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg ${isActive ? "text-secondary" : ""}`}
            to={{
              pathname: "/my-profile",
            }}>
            <span className={`py-2.5 pr-3  "block w-full"`}>{t("profile")}</span>
          </NavLink>
        </Disclosure>
        <Disclosure key={"Bookings & points"} as="li" className="text-neutral-900 dark:text-white">
          <NavLink
            end
            className={({ isActive }) => `flex w-full px-4 font-medium uppercase tracking-wide text-sm hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg ${isActive ? "text-secondary" : ""}`}
            to={{
              pathname: "/packages",
            }}>
            <span className={`py-2.5 pr-3  "block w-full"`}>{t("packages")}</span>
          </NavLink>
        </Disclosure>
        <Disclosure key={"payment-method"} as="li" className="text-neutral-900 dark:text-white">
          <NavLink
            end
            className={({ isActive }) => `flex w-full px-4 font-medium uppercase tracking-wide text-sm hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg ${isActive ? "text-secondary" : ""}`}
            to={{
              pathname: "/payment-method",
            }}>
            <span className={`py-2.5 pr-3  "block w-full"`}>{t("pay_done_payment_method")}</span>
          </NavLink>
        </Disclosure>
        <Disclosure key={"payment-method"} as="li" className="text-neutral-900 dark:text-white">
          <NavLink
            end
            className={({ isActive }) => `flex w-full px-4 font-medium uppercase tracking-wide text-sm hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg ${isActive ? "text-secondary" : ""}`}
            to={{
              pathname: "/terms-and-disclamier",
            }}>
            <span className={`py-2.5 pr-3  "block w-full"`}>{t("all_terms")}</span>
          </NavLink>
        </Disclosure>
      </>
    );
  };

  const _renderPublicItem = () => {
    return (
      <div className="nc-CardAuthorBox relative flex flex-col items-center justify-center text-center px-3 py-5 sm:px-6 sm:py-7   ">
        <span className="py-1.5 px-3 flex rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
          </svg>
        </span>
        <span className={` py-2.5 pr-3  "block w-full"`}>{t("alert_login_in")}</span>
      </div>
    );
  };

  return (
    <div className="overflow-y-auto w-full h-screen py-2 transition transform shadow-lg ring-1 dark:ring-neutral-700 bg-white dark:bg-neutral-900 divide-y-2 divide-neutral-100 dark:divide-neutral-800">
      <div className="py-6 px-5">
        <Logo />
        <div className="flex flex-col mt-5 text-neutral-700 dark:text-neutral-300 text-sm">
          <div className="flex justify-between items-center mt-4">
            {!isLoggedIn ? <ButtonThird href="/login">{t("signin")}</ButtonThird> : <ButtonThird onClick={_onLogout}>{t("signout")}</ButtonThird>}

            <span className="block">
              <LangDropdown panelClassName="z-10 w-screen max-w-[280px] px-4 mb-3 -right-3 bottom-full sm:px-0" />
            </span>
          </div>
        </div>
        <span className="absolute right-2 top-2 p-1">
          <ButtonClose onClick={onClickClose} />
        </span>
      </div>

      <ul className="flex flex-col py-6 px-2 space-y-1">{isLoggedIn ? _renderMemberItem() : _renderPublicItem()}</ul>

      <div className="flex flex-col items-center justify-center py-6">
        <div className="inline-block">
          <SocialsList itemClass="w-9 h-9 flex items-center justify-center rounded-full bg-neutral-100 text-xl dark:bg-neutral-800 dark:text-neutral-300" />
        </div>

        <span className="mt-7 text-sm text-gray-10 text-opacity-80">© 2024 Flying Lab. All rights reserved</span>
      </div>
    </div>
  );
};

export default NavMobile;
